import React from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Badge,
  Row,
  Col,
  Card,
  CardBody,
  Table,
  Alert,
} from "reactstrap";
import { formatDateTime } from "../../../Components/Common/FormatDate";

const OrderDetailModal = ({ isOpen, toggle, orderData }) => {
  console.log("🚀 ~ OrderDetailModal ~ orderData:", orderData);
  if (!orderData) {
    return (
      <Modal isOpen={isOpen} toggle={toggle}>
        <ModalHeader toggle={toggle}>Order Details</ModalHeader>
        <ModalBody>
          <Alert color="warning" className="mb-0">
            No order data available
          </Alert>
        </ModalBody>
      </Modal>
    );
  }

  const calculateTotal = () => {
    let total = orderData.price || 0;
    if (orderData.additionalPrice)
      total += parseFloat(orderData.additionalPrice);
    if (orderData.orderExtras) {
      total += orderData.orderExtras.reduce(
        (sum, extra) => sum + (extra.totalPrice || 0),
        0
      );
    }
    if (orderData.orderAddOns) {
      total += orderData.orderAddOns.reduce(
        (sum, addon) => sum + (addon.totalPrice || 0),
        0
      );
    }
    if (orderData.orderDetailChildren) {
      total += orderData.orderDetailChildren.reduce(
        (sum, child) => sum + (child.price || 0) * (child.quantity || 0),
        0
      );
    }
    if (orderData.sideItems) {
      orderData.sideItems.forEach((side) => {
        if (side.extras)
          total += side.extras.reduce(
            (sum, extra) => sum + (extra.totalPrice || 0),
            0
          );
        if (side.addOns)
          total += side.addOns.reduce(
            (sum, addon) => sum + (addon.totalPrice || 0),
            0
          );
      });
    }
    return total;
  };

  // const formatDate = (dateString) => {
  //   if (!dateString) return "N/A";
  //   return new Date(dateString).toLocaleDateString();
  // };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle} className="border-0 pb-0">
        <div className="d-flex justify-content-between align-items-center w-100">
          <span>{orderData.productName || "N/A"}</span>
          <Badge color="success" className="ms-3" pill>
            ${calculateTotal().toFixed(2)}
          </Badge>
        </div>
      </ModalHeader>
      <ModalBody className="pt-2">
        <Card className="border-0 mb-3">
          <CardBody className="p-3">
            <div className="d-flex justify-content-between text-muted small mb-1">
              <span>Total Price</span>
              <span>${(orderData.price || 0).toFixed(2)}</span>
            </div>
            <div className="d-flex justify-content-between text-muted small">
              <span>Date</span>
              <span>{formatDateTime(orderData.createdDate)}</span>
            </div>
          </CardBody>
        </Card>

        {orderData.orderAddOns?.length > 0 && (
          <Card className="border-0 mb-3">
            <CardBody className="p-3">
              <h6 className="mb-3">Add-ons</h6>
              {orderData.orderAddOns.map((addon) => (
                <div
                  key={addon.id}
                  className="d-flex justify-content-between mb-2"
                >
                  <span>
                    {addon.name || "N/A"} × {addon.qty || 0}
                  </span>
                  <span>${(addon.totalPrice || 0).toFixed(2)}</span>
                </div>
              ))}
            </CardBody>
          </Card>
        )}

        {orderData.orderExtras?.length > 0 && (
          <Card className="border-0 mb-3">
            <CardBody className="p-3">
              <h6 className="mb-3">Extras</h6>
              {orderData.orderExtras.map((extra) => (
                <div
                  key={extra.id}
                  className="d-flex justify-content-between mb-2"
                >
                  <span>
                    {extra.name || "N/A"} × {extra.qty || 0}
                  </span>
                  <span>${(extra.totalPrice || 0).toFixed(2)}</span>
                </div>
              ))}
            </CardBody>
          </Card>
        )}

        {orderData.orderDetailChildren?.length > 0 && (
          <Card className="border-0 mb-3">
            <CardBody className="p-3">
              <h6 className="mb-3">Included Items</h6>
              {orderData.orderDetailChildren.map((child, index) => (
                <div
                  key={index}
                  className="d-flex justify-content-between mb-2"
                >
                  <span>
                    {child.productName || "N/A"} × {child.quantity || 0}
                  </span>
                  <span>
                    ${((child.price || 0) * (child.quantity || 0)).toFixed(2)}
                  </span>
                </div>
              ))}
            </CardBody>
          </Card>
        )}

        {orderData.sideItems?.length > 0 && (
          <Card className="border-0 mb-3">
            <CardBody className="p-3">
              <h6 className="mb-3">Side Items</h6>
              {orderData.sideItems.map((side, index) => (
                <div key={index} className="mb-3">
                  <div className="d-flex justify-content-between mb-2">
                    <span>{side.sideName || "N/A"}</span>
                  </div>
                  {side.extras?.length > 0 &&
                    side.extras.map((extra, i) => (
                      <div
                        key={i}
                        className="d-flex justify-content-between small text-muted ms-3"
                      >
                        <span>
                          {extra.name || "N/A"} × {extra.qty || 0}
                        </span>
                        <span>${(extra.totalPrice || 0).toFixed(2)}</span>
                      </div>
                    ))}
                  {side.addOns?.length > 0 &&
                    side.addOns.map((addon, i) => (
                      <div
                        key={i}
                        className="d-flex justify-content-between small text-muted ms-3"
                      >
                        <span>
                          {addon.name || "N/A"} × {addon.qty || 0}
                        </span>
                        <span>${(addon.totalPrice || 0).toFixed(2)}</span>
                      </div>
                    ))}
                </div>
              ))}
            </CardBody>
          </Card>
        )}

        <div className="d-flex justify-content-between align-items-center pt-2">
          <h5 className="mb-0">Total</h5>
          <h5 className="mb-0">${calculateTotal().toFixed(2)}</h5>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default OrderDetailModal;
